import React, { useEffect, useState } from 'react';
import { IonAlert } from '@ionic/react';

const UpdateAlert: React.FC = () => {
    const [showUpdateAlert, setShowUpdateAlert] = useState(false);
    const [waitingServiceWorker, setWaitingServiceWorker] = useState<ServiceWorker | null>(null);

    useEffect(() => {
        // Check if service workers are supported
        if ('serviceWorker' in navigator) {
            // When the service worker is ready
            navigator.serviceWorker.ready.then(registration => {
                // Check for updates on initial load
                registration.update();
                
                // Set up periodic check for updates (every 60 minutes)
                const intervalId = setInterval(() => {
                    console.log('Checking for updates...');
                    registration.update();
                }, 60 * 60 * 1000);
                
                // Listen for new service worker waiting
                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing;
                    
                    if (newWorker) {
                        newWorker.addEventListener('statechange', () => {
                            // When the service worker is installed and waiting
                            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                                console.log('New version available! Showing update alert.');
                                setWaitingServiceWorker(registration.waiting);
                                setShowUpdateAlert(true);
                            }
                        });
                    }
                });
                
                return () => clearInterval(intervalId);
            });
        }
    }, []);

    const handleUpdate = () => {
        if (waitingServiceWorker) {
            // Send message to service worker to skip waiting and activate new version
            waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
            
            // Reload the page to load the new version
            window.location.reload();
        }
        setShowUpdateAlert(false);
    };

    return (
        <IonAlert
            isOpen={showUpdateAlert}
            backdropDismiss={false} // Prevent dismissing by tapping outside
            header="Update Available"
            message="A new version of the app is available. Please update to continue."
            buttons={[
                {
                    text: 'Update Now',
                    handler: handleUpdate,
                }
            ]}
        />
    );
};

export default UpdateAlert;